/**
 * Questions View
 * This is the main view of the Questions and Answers
 */
define("Questions.View", [
  "SCView",
  "Question.Collection",
  "Questions.Collection.View",
  "Backbone.CollectionView",
  "questions.tpl",
  "Question.Model",
  "Question.View",
], function (
  SCViewComponent,
  QuestionCollection,
  QuestionCollectionView,
  BackboneCollectionView,
  template,
  QuestionModel,
  QuestionView
) {
  "use strict";
  var SCView = SCViewComponent.SCView;

  function QuestionsView(options) {
    SCView.call(this, options.collection);
    this.template = template;
    var self = this;

	//to inject extra SEO data
	this.questionsAndAnswerSEO = null;

	this.layoutComponent = options.application.getComponent('Layout');

    //Get Results Per Page from SC Configuration
    this.resultsPerPage = SC.CONFIGURATION.questionsAndAnswers.resultsPerPage;

    // Array with the pages and the active property
    this.totalPages = [];
    this.currentPage = 0;
    this.application = options.application;
    this.model = new QuestionModel();
    this.item = options.item;
    this.isLoggedIn = options.isLoggedIn;
    this.internalId = options.internalId;

    this.model
      .fetch({
        data: {
          counter: true,
          itemid: JSON.stringify(this.item.item.internalid),
        },
      })
      .done(function (totalOfResults) {
        var totalOfPages = Math.ceil(
          totalOfResults.length / self.resultsPerPage
        );
        // flag to show 'Be the first to write a question.' message
        self.total_qa = parseInt(totalOfResults.length);
        for (var i = 0; i < totalOfPages; i++) {
          self.totalPages.push({
            page: i,
            active: false,
            number: i + 1,
          });
        }

        // first is active
        if (self.totalPages && self.totalPages.length > 0) {
          self.totalPages[self.currentPage].active = true;
        }

        // set range on initial load
        if (self.totalPages && self.totalPages.length > 0) {
          self.pageNumber = self.totalPages[self.currentPage].number;
          self.endRange = self.pageNumber * self.resultsPerPage;
          self.startRange = self.endRange / self.resultsPerPage;

          if (self.resultsPerPage > self.total_qa) {
            self.endRange = self.total_qa;
            self.startRange = 1;
          }
        }

        // show back page button on initial load
        self.show_back = false;
        self.backPage = self.currentPage - 1;
        if (self.pageNumber > 1) {
          self.show_back = true;
        }

        // show next page button on initial load
        self.show_next = false;
        self.nextPage = self.currentPage + 1;
        if (self.totalPages.length > 1) {
          self.show_next = true;
        }
        self.render();
      });
    this.collection = new QuestionCollection(
      {},
      {
        itemid: this.item.item.internalid,
        page: this.currentPage,
      }
    );
    // return the fetch 'promise'
    this.collection
      .fetch({
        data: {
          counter: false,
          page: this.currentPage,
          resultsPerPage: self.resultsPerPage,
          itemid: JSON.stringify(this.item.item.internalid),
        },
      })
      .done(function (response) {
        self.render();

		var questionsAndAnswers = self.collection && self.collection.models || [];

		var questionListForSEO = [];

		_.each(questionsAndAnswers , function(questionAndAnswer){
				console.log(questionAndAnswer);
				console.log(questionAndAnswer.get('answer'));

				var questionElement = {
					"@type": "Question",
					"name": questionAndAnswer.get('question'),
					"acceptedAnswer": {
					  "@type": "Answer",
					  "text": questionAndAnswer.get('answer')
					}
				};

				questionListForSEO.push(questionElement);
				
			}
		);

		if(questionListForSEO && questionListForSEO.length > 0){


			var jsonLdWithContext = {
				"@type": "FAQPage", 
				"mainEntity": [
					questionListForSEO
				]	
			};

			self.questionsAndAnswerSEO = jsonLdWithContext;
		}

		self.layoutComponent.modifyViewJsonLd('ProductDetails.Full.View', function(json) {

			//Source: https://www.schemaapp.com/schema-markup/stand-out-in-search-with-faq-rich-results/

			if(self.questionsAndAnswerSEO){
				json = _.extend(json, {
					subjectOf: self.questionsAndAnswerSEO
				});
			}
			
			return jQuery.Deferred().resolve(json);
		});


      })
      .then(function () {});

  }

  QuestionsView.prototype = Object.create(SCView.prototype);
  QuestionsView.prototype.constructor = QuestionsView;

  QuestionsView.prototype.getEvents = function () {
    return {
      "click #submit-question": "submitQuestion",
      "click .pagination a": "renderQuestions",
      "focus #question-text": "clearInputQuestion",
      "focus #displayname": "clearInputDisplayName",
    };
  };
  QuestionsView.prototype.getChildViews = function () {
    return {
      QAndACollection: function (model) {
        return new QuestionCollectionView({
          collection: this.collection,
          model: model,
        });
      },
    };
  };

  QuestionsView.prototype.getContext = function () {
    var self = this;
    var hash = Backbone.history.fragment;
    var qty_questions = self.total_qa;
    var hasQuestions = qty_questions > 0;
    var show_msg = false;

    // show message
    if (!qty_questions) {
      show_msg = true;
    }

    // set noun form for question
    var plural = "";

    if (self.total_qa > 1) {
      plural = "s";
    }

    return {
      //@property {Boolean} if 0 is not logged in
      isLoggedIn: self.isLoggedIn,
      page: self.currentPage,
      backPage: self.backPage,
      nextPage: self.nextPage,
      totalPages: self.totalPages,
      totalQuestions: self.total_qa,
      endRange: self.endRange,
      startRange: self.startRange,
      hash: hash,
      show_msg_first_msg: show_msg,
      show_back: self.show_back,
      show_next: self.show_next,
      hasQuestions: hasQuestions,
      plural: plural,
    };
  };

  QuestionsView.prototype.submitQuestion = function () {
    if ($("#question-text").val() != "" && $("#displayname").val() != "") {
      var self = this;
      // Id of the product

      var productId = self.item.item.internalid;
      var customerId = self.internalId;
      // Question to push on the backend
      var question = this.$("#question-text").val();
      var displayName = this.$("#displayname").val();
      var questionModel = new QuestionModel();
      questionModel.set("question", question);
      questionModel.set("displayname", displayName);
      questionModel.set("customerid", customerId);
      questionModel.set("productid", productId);
      questionModel.set("requestType", "create");
      questionModel
        .save()
        .then(function (response) {
          var y = response;
        })
        .fail(function (e) {
          var a = e;
        });
      $("#question-text").val("");
      $("#displayname").val("");
      $("#success-msg").css("display", "block");
    } else if (
      $("#question-text").val() == "" &&
      $("#displayname").val() == ""
    ) {
      $("#empty-msg").css("display", "block");
      $("#empty-displayname").css("display", "block");
    } else if ($("#question-text").val() == "") {
      $("#empty-msg").css("display", "block");
    } else if ($("#displayname").val() == "") {
      $("#empty-displayname").css("display", "block");
    }
  };

  QuestionsView.prototype.renderQuestions = function (e) {
    var self = this;
    // remove active
    self.totalPages[self.currentPage].active = false;
    // Page
    var page = this.$(e.target).data("page");
    self.currentPage = page;
    this.collection = new QuestionCollection(
      {},
      {
        itemid: this.item.item.internalid,
        page: page,
      }
    );
    // return the fetch 'promise'
    this.collection
      .fetch({
        data: {
          counter: false,
          page: page,
          resultsPerPage: self.resultsPerPage,
          itemid: JSON.stringify(this.item.item.internalid),
        },
      })
      .done(function () {
        self.render();
      })
      .then(function () {});

    // set new active
    self.totalPages[self.currentPage].active = true;

    // set page number on pagination click
    self.pageNumber = self.totalPages[self.currentPage].number;

    // show back page button on pagination click
    self.show_back = false;
    self.backPage = self.currentPage - 1;
    if (self.pageNumber > 1) {
      self.show_back = true;
    }

    // show next page button on pagination click
    self.show_next = false;
    self.nextPage = self.currentPage + 1;

    var lastPage = self.totalPages.length == self.pageNumber ? true : false;

    if (self.totalPages.length > 1 && !lastPage) {
      self.show_next = true;
    }

    // set range on pagination click

    self.startRange = "";
    self.endRange = "";

    if (self.resultsPerPage > self.total_qa) {
      self.endRange = self.total_qa;
      self.startRange = 1;
    } else {
      if (self.pageNumber == 1) {
        self.endRange = self.pageNumber * self.resultsPerPage;
        self.startRange = self.endRange / self.resultsPerPage;
      }
      if (self.totalPages.length == self.pageNumber) {
        self.startRange = self.resultsPerPage * (self.pageNumber - 1) + 1;
        self.endRange = self.total_qa;
      } else {
        self.startRange = self.resultsPerPage * (self.pageNumber - 1) + 1;
        self.endRange = self.resultsPerPage * self.pageNumber;
      }
    }

    this.getChildViews("QuestionView");
  };

  QuestionsView.prototype.clearInputQuestion = function () {
    $("#empty-msg").css("display", "none");
  };

  QuestionsView.prototype.clearInputDisplayName = function () {
    $("#empty-displayname").css("display", "none");
  };

  return QuestionsView;
});
